import { render, staticRenderFns } from "./PhoneQuestion.vue?vue&type=template&id=2e4e330a&"
import script from "./PhoneQuestion.vue?vue&type=script&lang=js&"
export * from "./PhoneQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports